import React from "react";

import Auth from "../components/layout/Auth";
import { Button } from "@material-ui/core";
import { PanToolRounded } from "@material-ui/icons";
import { Auth_Style } from "../assets/css/Styles";
import i18n from "../locales/i18n";
import AuthService from "../services/AuthService";
import { useAuth0 } from "@auth0/auth0-react";

export default function Unauthorized(props) {  
  const { logout } = useAuth0();
  const styles = Auth_Style();
  
  return (
    <Auth>
      <h3 className={styles.authTitle}>
        {i18n.t("unauthorized.title")}
        <PanToolRounded />
      </h3>
      <div className={styles.authMessage}>{i18n.t("unauthorized.text")}</div>
      <div className={styles.authButtonContainer}>
        <Button
          variant="outlined"
          className={styles.authSecondaryButton}
          onClick={() => {
            localStorage.setItem("fromLogOut", "true");
            logout({
              logoutParams: {
                returnTo: window.location.origin,
              },
            });
          }}
        >
          {i18n.t("sidebar.cerrarSesion")}
        </Button>
        <Button
          variant="contained"
          className={styles.authButton}
          onClick={() => {
            window.location.href = "/";
          }}
        >
          {i18n.t("unauthorized.btn_goback")}
        </Button>
      </div>
    </Auth>
  );
}
